import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);

/**
 * 时间校验判断,闭区间。
 * 支持三种场景：startTime<=now, now<=endTime, startTime<=now<=endTime。
 * 为了规范时间流通类型，这里只支持传入Date
 * */
export const checkDateBetween = ({ startTime, endTime, now }:
{ startTime?: Date, endTime?: Date, now: Date }) => {
  if (startTime && endTime) {
    return dayjs(now).isBetween(dayjs(startTime), dayjs(endTime), null, '[]');
  }
  if (startTime) {
    return dayjs(now).isSameOrAfter(dayjs(startTime));
  }
  if (endTime) {
    return dayjs(endTime).isSameOrAfter(dayjs(now));
  }
  return false;
};
